import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { Router, RouterModule } from '@angular/router';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxIconModule } from '@nrwl/rx-icon';
import { AuthService } from '@nrwl/rx-service-auth';
import { RouterService } from '@nrwl/rx-service-router';
import { AdsBannerComponent } from '../../ads-banner/ads-banner.component';

@Component({
  selector: 'nrwl-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RxButtonModule,
    RouterModule,
    RxIconModule,
    MatCardModule,
    AdsBannerComponent,
  ],
})
export class ResetPasswordComponent implements OnInit {
  public loginError: string;

  public get currentYear() {
    return new Date().getUTCFullYear();
  }

  constructor(
    private router: Router,
    private routerService: RouterService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.loginError = '';
    this.authService.clearStorage();
  }

  public get title(): string {
    return this.routerService.data.title;
  }

  public backToLogin(): void {
    this.router.navigate(['login']); // v19
  }

  public navigateToKnowledgebase() {
    window.open('https://kb.rxphoto.com/portal/en/kb', '_blank');
  }
}
